export default class OrdersDataProvider {
  constructor(Orders) {
    "ngInject"
    this.OrdersService = Orders;
  }

  updateOrder(data, type) {
    return this.OrdersService
      .updateOrder(data, type)
      .then((resp) => {
        return resp;
      })
  }

  getOrders(data) {
    return this.OrdersService.loadOrders(data)
      .then((result) => {
        return result;
      })
  }

  getOrder(id) {
    return this.OrdersService.getOrder(id)
      .then((result) => {
        return result;
      })
  }

  getItems(id) {
    return this.OrdersService.getItems(id)
      .then((result) => {
        return result;
      })
  }

  getOrderStatusLogs(id) {
    return this.OrdersService.getOrderStatusLogs(id)
      .then((result) => {
        return result;
      })
  }

  updateOrderStatus(data) {
    return this.OrdersService
      .updateOrderStatus(data)
      .then((resp) => {
        return resp;
      })
  }

  resetOrderStatus(id) {
    return this.OrdersService
      .resetOrderStatus(id)
      .then((resp) => {
        return resp;
      })
  }

  updateInvoiceId(data) {
    return this.OrdersService
      .updateInvoiceId(data)
      .then((resp) => {
        return resp;
      })
  }

  getComments(id) {
    return this.OrdersService
      .getComments(id)
      .then((resp) => {
        return resp;
      })
  }

  saveComments(data) {
    return this.OrdersService
      .saveComments(data)
      .then((resp) => {
        return resp;
      })
  }

  removeComment(id) {
    return this.OrdersService
      .removeComment(id)
      .then((resp) => {
        return resp;
      })
  }

  sendShippedMail(id) {
    return this.OrdersService
      .sendShippedMail(id)
      .then((resp) => {
        return resp;
      })
  }

  sendInvoiceMail(id) {
    return this.OrdersService
      .sendInvoiceMail(id)
      .then((resp) => {
        return resp;
      })
  }

  sendCollectionMail(id) {
    return this.OrdersService
      .sendCollectionMail(id)
      .then((resp) => {
        return resp;
      })
  }
  sendReceiptMail(id) {
    return this.OrdersService
      .sendReceiptMail(id)
      .then((resp) => {
        return resp;
      })
  }
  sendReviewMail(id) {
    return this.OrdersService
      .sendReviewMail(id)
      .then((resp) => {
        return resp;
      })
  }
  sendPaperInvoiceMail(id) {
    return this.OrdersService
      .sendPaperInvoiceMail(id)
      .then((resp) => {
        return resp;
      })
  }
  sendReminderInvoiceMail(id) {
    return this.OrdersService
      .sendReminderInvoiceMail(id)
      .then((resp) => {
        return resp;
      })
  }

  saveShipmentResp(data) {
    return this.OrdersService
      .saveShipmentResp(data)
      .then((resp) => {
        return resp;
      })
  }

  tosvg(data) {
    return this.OrdersService
      .tosvg(data)
      .then((resp) => {
        return resp;
      })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/orders/services/order.dataprovider.service.js
 **/